import { Component, output, ChangeDetectionStrategy } from '@angular/core'
import { SidebarNavLinkComponent } from '../sidebar-nav-link/sidebar-nav-link.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'

@Component({
    selector: 'sq-sidebar-footer',
    imports: [FontAwesomeModule],
    templateUrl: './sidebar-footer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        class: 'sidebar-footer border-top',
    },
})
export class SidebarFooterComponent {
    logout = output<void>()

    logoutClicked(): void {
        this.logout.emit()
    }
}
